import { LanguageSelectionHelper } from "app/helpers/languageSelectionHelper";
import type { EventType } from "app/types/eventType";
import React, { Component } from "react";
import "./BetRadarMobileWidgetCollapsed.scss";

type Props = {
  event: EventType;
  sourceFixtureId: string;
};
//
class BetRadarMobileWidgetCollapsed extends Component<Props> {
  myRef: any;
  constructor(props: Props) {
    super(props);
    this.myRef = React.createRef();
  }

  componentDidMount() {
    this.loadWidgetScript();
  }
  // temp code until invert feature fully integrated on API side
  checkInvertTeams = () => {
    const { event } = this.props;
    return event.showHomePlayerAsFirst ? false : true;
  };

  loadWidgetScript = () => {
    const script = document.createElement("script");
    const { event, sourceFixtureId } = this.props;
    // temp check if teams need to be inverted
    let forceTeamInvert = this.checkInvertTeams();
    const jsCode = `(function(a,b,c,d,e,f,g,h,i){a[e]||(i=a[e]=function(){(a[e].q=a[e].q||[]).push(arguments)},i.l=1*new Date,i.o=f,
    g=b.createElement(c),h=b.getElementsByTagName(c)[0],g.async=1,g.src=d,g.setAttribute("n",e),h.parentNode.insertBefore(g,h)
    )})(window,document,"script", "https://widgets.sir.sportradar.com/d2c29f4b2e59b152fffff687da860589/widgetloader", "SIR", {
        theme: false, // using custom theme
        language: "${LanguageSelectionHelper.checkSelectedLanguageBetRadarWidget()}",
    });
    SIR("addWidget", ".sr-widget-1", "match.lmtCompact", {forceTeamInvert: ${forceTeamInvert}, matchId:${sourceFixtureId}});`;
    script.appendChild(document.createTextNode(jsCode));
    this.myRef.appendChild(script);
    this.myRef.classList.add("bet-radar-script");
  };

  componentDidUpdate = (nextProps: { event: EventType }) => {
    // BET-9328
    if (nextProps.sourceFixtureId !== this.props.sourceFixtureId) {
      this.loadWidgetScript();
    }
  };

  render() {
    // check if sport is soccer or else return blank div
    return (
      <div className="bet-radar-widget-wrapper">
        <div className="widgets">
          <div>
            <div className="sr-widget sr-widget-1"></div>
          </div>
        </div>
        <div
          ref={DOMNodeRef => {
            this.myRef = DOMNodeRef;
          }}
        ></div>
      </div>
    );
  }
}

export default BetRadarMobileWidgetCollapsed;
